import { Avatar, Grid } from "@mui/material";
import React, { useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import KeyIcon from "@mui/icons-material/Key";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { API_URL1 } from "../services/url";
import { useAlert } from "react-alert";

const useStyles = makeStyles({
  root: {
    [`& fieldset`]: {
      borderRadius: 10,
    },
  },
});

const EditPassword = (porps) => {
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [btn_Status, setBtn_Status] = useState("unclick");
  const [allfieldError, setAllfieldError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (oldPass !== "" && newPass !== "" && confirmPass !== "") {
      setAllfieldError(false);
      setBtn_Status("click");
      const data = {
        oldpassword: oldPass,
        password: newPass,
      };

      if (newPass !== confirmPass) {
        alert.error("Passwords don't match");
      } else {
        try {
          const res = await axios.post(`${API_URL1}trucker/resetPass`, data, {
            headers: {
              "x-access-token": `${localStorage.getItem("TruckertokenKey")}`,
              "content-type": "application/json",
            },
          });

          if (res.data.success) {
            alert.success(res.data.message);
            localStorage.removeItem("TruckertokenKey");
            window.location = "/";
          } else {
            alert.error(res.data.message);
          }
        } catch (err) {
          alert.error("something went wrong");
        }
      }
    } else {
      setAllfieldError(true);
    }
  };

  const alert = useAlert();
  const classes = useStyles();
  const companyName = localStorage.getItem("company_name") || "U";
  
  return (
    <div style={{ marginTop: "0px", padding: "24px" }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, pl: '8px' }}>
        <Box sx={{
          width: 46, height: 46, borderRadius: 2,
          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 6px 12px rgba(99,102,241,0.25)'
        }}>
          <KeyIcon htmlColor="#fff" />
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', letterSpacing: 0.2 }}>Reset Password</Typography>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          maxWidth: 800,
          mx: 'auto',
          background: "#ffffff",
          border: '1px solid #e5e7eb',
          boxShadow: '0 8px 20px rgba(2,6,23,0.06)',
          borderRadius: "16px",
          p: 4,
        }}
      >
        <Avatar
          sx={{
            mt: "8px",
            mb: 3,
            mx: 'auto',
            width: 100,
            height: 100,
            bgcolor: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            color: '#ffffff',
            fontWeight: 800,
            fontSize: 36,
            boxShadow: '0 8px 16px rgba(99,102,241,0.25)'
          }}
        >
          {companyName.charAt(0).toUpperCase()}
        </Avatar>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{ mb: 1 }}
                fontSize="14px"
                align="left"
                fontWeight="bold"
                color="#374151"
              >
                Current Password
              </Typography>
              <TextField
                sx={{
                  background: '#f8fafc',
                  borderRadius: '12px!important',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#e5e7eb', borderRadius: '12px' },
                    '&:hover fieldset': { borderColor: '#cbd5e1' },
                    '&.Mui-focused fieldset': { borderColor: '#6366f1', boxShadow: '0 0 0 3px rgba(99,102,241,0.15)' }
                  }
                }}
                type="password"
                value={oldPass}
                onChange={(e) => setOldPass(e.target.value)}
                size="small"
                className={classes.root}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{ mb: 1 }}
                fontSize="14px"
                align="left"
                fontWeight="bold"
                color="#374151"
              >
                New Password
              </Typography>
              <TextField
                sx={{
                  background: '#f8fafc',
                  borderRadius: '12px!important',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#e5e7eb', borderRadius: '12px' },
                    '&:hover fieldset': { borderColor: '#cbd5e1' },
                    '&.Mui-focused fieldset': { borderColor: '#6366f1', boxShadow: '0 0 0 3px rgba(99,102,241,0.15)' }
                  }
                }}
                value={newPass}
                type="password"
                onChange={(e) => setNewPass(e.target.value)}
                size="small"
                className={classes.root}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{ mb: 1 }}
                fontSize="14px"
                align="left"
                fontWeight="bold"
                color="#374151"
              >
                Confirm Password
              </Typography>
              <TextField
                sx={{
                  background: '#f8fafc',
                  borderRadius: '12px!important',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#e5e7eb', borderRadius: '12px' },
                    '&:hover fieldset': { borderColor: '#cbd5e1' },
                    '&.Mui-focused fieldset': { borderColor: '#6366f1', boxShadow: '0 0 0 3px rgba(99,102,241,0.15)' }
                  }
                }}
                value={confirmPass}
                type="password"
                onChange={(e) => setConfirmPass(e.target.value)}
                size="small"
                className={classes.root}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3.5,
                  textTransform: "none",
                  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                  borderRadius: "999px",
                  boxShadow: '0 8px 16px rgba(99,102,241,0.25)',
                  '&:hover': { background: 'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)', boxShadow: '0 12px 20px rgba(124,58,237,0.35)' }
                }}
              >
                <b> Save </b>
              </Button>
            </Grid>
          </Grid>
        </form>
        {allfieldError ? (
          <Typography sx={{ color: "red", marginTop: '16px', textAlign: 'center' }}>All Fields Required</Typography>
        ) : null}
      </TableContainer>
    </div>
  );
};

export default EditPassword;
